import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ElectronicAccessoriesPage } from './electronic-accessories.page';

const routes: Routes = [
  {
    path: '',
    component: ElectronicAccessoriesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ElectronicAccessoriesPageRoutingModule {}
